/**
 * Elsi signing canvas width
 */
export const SIGNING_PAD_WIDTH = 800;

/**
 * Elsi signing canvas height
 */
export const SIGNING_PAD_HEIGHT = 300;

/**
 * Minimum signature size in px
 */
export const MIN_SIGNATURE_LENGTH = 30;

/**
 * Value to scale signatures from original size
 * Increase this value to increase signature size
 * Decrease this value to decrease signature size
 */
export const SIGNATURES_SCALE = 0.5;

/**
 * Default page width in px.
 * Used for calculating signatures scale
 */
export const PAGE_WIDTH = 1224;

/**
 * Default page width in px when the page is loaded on large screen.
 */
export const PAGE_WIDTH_INITIAL = 700;

/**
 * Minimum page width in px
 */
export const MIN_PAGE_ZOOM = 500;

/**
 * Maximum page width in px
 */
export const MAX_PAGE_ZOOM = 2500;

/**
 * Tab types for Elsi signing
 */
export enum ElsiTabType {
  SIGNATURE = 'Signature',
  INITIALS = 'Initial',
  DATE = 'DateSigned',
  FREEFORM = 'Freeform',
  SELECTION = 'Selection',
  CONTENT = 'Content',
  PREFILLED_TEXT = 'PreFilledText',
}

/**
 * Autotag and elsi default tab values.
 * Default height is used to checkif tab is input or textarea
 */
export const DEFAULT_TAB_HEIGHT = 0.027;
export const DEFAULT_TAB_WIDTH = 0.2;
export const DEFAULT_INITIAL_WIDTH = 0.05;
export const DEFAULT_SELECTION_TAB = 0.025;
/**
 * Maximum signature height in px
 * Signatures with height greater than this value will be scaled
 */
export const MAX_SIGNATURE_HEIGHT = 45;

/**
 * Default text formatting for Content and PrefilledText tabs.
 * Matches current fabric.IText hardcodes (helvetica / 22 / weight 400).
 */
export const DEFAULT_TAB_FONT = 'helvetica';
export const DEFAULT_TAB_FONT_SIZE = 22;
export const DEFAULT_TAB_COLOR = '#000000';
export const DEFAULT_TAB_BOLD = false;
export const DEFAULT_TAB_ITALIC = false;
export const DEFAULT_TAB_UNDERLINE = false;
/** Unitless fabric.IText lineHeight multiplier */
export const DEFAULT_TAB_LINE_HEIGHT = 1.16;

/** Display name → Fabric/CSS fontFamily (matches DEFAULT_TAB_FONT casing) */
export const FONT_OPTIONS = [
  { name: 'Arial', value: 'arial' },
  { name: 'Courier New', value: 'courier new' },
  { name: 'Lucida Console', value: 'lucida console' },
  { name: 'Helvetica', value: 'helvetica' },
  { name: 'Tahoma', value: 'tahoma' },
  { name: 'Times New Roman', value: 'times new roman' },
  { name: 'Verdana', value: 'verdana' },
];

/** Display name → Fabric/CSS-safe hex for color dropdowns */
export const COLOR_OPTIONS = [
  { name: 'Black', value: '#000000' },
  { name: 'White', value: '#FFFFFF' },
  { name: 'Navy Blue', value: '#000080' },
  { name: 'Bright Blue', value: '#0080FF' },
  { name: 'Purple', value: '#800080' },
  { name: 'Dark Red', value: '#8B0000' },
  { name: 'Bright Red', value: '#FF0000' },
  { name: 'Gold', value: '#FFD700' },
  { name: 'Green', value: '#008000' },
  { name: 'Dark Green', value: '#006400' },
];

/** Display size → Fabric fontSize (display / SIGNATURES_SCALE) */
export const FONT_SIZE_OPTIONS = [
  7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,
].map((size) => ({
  name: String(size),
  value: size / SIGNATURES_SCALE,
}));
